// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetOuterApiConfigsByIdParam,
    BaseResponseOuterApiConfigFoundResponse,
    PutOuterApiConfigsByIdParam,
    PutOuterApiConfigsByIdBody,
    BaseResponseVoid,
    DeleteOuterApiConfigsByIdParam,
} from '../../types';

/**
 * findById
 *
 * @export
 * @tags 语义智能-外部接口配置
 * @link [GET] /outerApiConfigs/{id}
 * @param id
 */
export function getOuterApiConfigsById(
    options: ApiOptions<GetOuterApiConfigsByIdParam, never> & {
        segments: GetOuterApiConfigsByIdParam;
    }
): Promise<BaseResponseOuterApiConfigFoundResponse> {
    return request<never, GetOuterApiConfigsByIdParam, never>('/outerApiConfigs/{id}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getOuterApiConfigsById',
    });
}

/**
 * update
 *
 * @export
 * @tags 语义智能-外部接口配置
 * @link [PUT] /outerApiConfigs/{id}
 * @param id
 */
export function putOuterApiConfigsById(
    data: PutOuterApiConfigsByIdBody,
    options: ApiOptions<PutOuterApiConfigsByIdParam, never> & {
        segments: PutOuterApiConfigsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<PutOuterApiConfigsByIdBody, PutOuterApiConfigsByIdParam, never>(
        '/outerApiConfigs/{id}',
        { ...options, data, method: 'put', __$requestCalleeName: 'putOuterApiConfigsById' }
    );
}

/**
 * deleteById
 *
 * @export
 * @tags 语义智能-外部接口配置
 * @link [DELETE] /outerApiConfigs/{id}
 * @param id
 */
export function deleteOuterApiConfigsById(
    options: ApiOptions<DeleteOuterApiConfigsByIdParam, never> & {
        segments: DeleteOuterApiConfigsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteOuterApiConfigsByIdParam, never>('/outerApiConfigs/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteOuterApiConfigsById',
    });
}

export const meta = [
    { tags: ['语义智能-外部接口配置'], path: '/outerApiConfigs/{id}', method: 'get' },
    { tags: ['语义智能-外部接口配置'], path: '/outerApiConfigs/{id}', method: 'put' },
    { tags: ['语义智能-外部接口配置'], path: '/outerApiConfigs/{id}', method: 'delete' },
];
